import React, { PureComponent } from 'react';
import { Row, Col, Input, Card, Tag, Popover, Tooltip, Tabs, Badge, Switch } from 'antd';
import styles from './index.less';
import SingleSignatureResourcesTable from './SingleSignatureResourcesTable';
import SingleSignatureRemediationSteps from './SingleSignatureRemediationSteps';
import Playbooks from './Playbooks';

const { Meta } = Card;
const { TabPane } = Tabs;

class SingleSignatureTabs extends PureComponent {
  state = {
    showSuppress: false,
  };
  render() {
    const { showSuppress } = this.state;
    let {
      remediationSteps,
      activeTab,
      onChange,
      suppressResourceCount,
      allCloudAccountsList,
      selectedCloudAccounts,
      organisation,
      drawerLoading,
      currentUser,
      description,
      signatureName,
      cloudAccounts,
      service,
      riskType,
      failedResources = [],
      passedResources = [],
    } = this.props;

    let signatureResourcesTableProps = {
      filteredResourcesOfSingleRisk: failedResources,
      allCloudAccountsList,
      selectedCloudAccounts,
      organisation,
      description,
      currentUser,
      drawerLoading,
      signatureName,
      showSuppress,
      riskType,
    };

    let signaturePassedResourcesTableProps = {
      filteredResourcesOfSingleRisk: passedResources,
      allCloudAccountsList,
      selectedCloudAccounts,
      organisation,
      description,
      currentUser,
      drawerLoading,
      showSuppress,
    };

    const failedResourcesCount = failedResources?.filter(v => !v.suppress).length;
    const passedResourcesCount = passedResources?.filter(v => !v.suppress).length;

    return (
      <div>
        <Card
          bodyStyle={{ paddingTop: '0px' }}
          style={{ margin: '20px -39px -20px' }}
          bordered={false}
        >
          <Tabs
            activeKey={activeTab}
            onChange={onChange}
            tabBarExtraContent={
              <div style={{ marginRight: '40px' }}>
                <Badge
                  showZero
                  count={suppressResourceCount}
                  overflowCount={1000}
                  style={{
                    background: '#228FFD',
                    color: 'white',
                    fontWeight: 600,
                    marginTop: -3,
                    marginRight: 7,
                  }}
                />
                Suppressed Resources &nbsp;
                <Switch
                  checkedChildren="Hide"
                  unCheckedChildren="Show"
                  onChange={checked => {
                    this.setState({
                      showSuppress: checked,
                    });
                  }}
                />
              </div>
            }
          >
            {/* //~ FAILED TAB */}
            <TabPane
              tab={
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <span style={{ marginRight: '15px' }}>Failed</span>
                  <Badge
                    showZero
                    count={failedResourcesCount}
                    overflowCount={1000}
                    style={{
                      background: '#F4657C',
                      color: 'white',
                      fontWeight: 600,
                      marginRight:
                        failedResourcesCount > 99
                          ? '-7px'
                          : failedResourcesCount > 9
                          ? '-4px'
                          : '-1px',
                    }}
                  />
                </div>
              }
              key="1"
            >
              <SingleSignatureResourcesTable {...signatureResourcesTableProps} />
            </TabPane>
            {passedResources.length > 0 && (
              <TabPane
                tab={
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <span style={{ marginRight: '15px' }}>Passed</span>
                    <Badge
                      showZero
                      count={passedResourcesCount}
                      overflowCount={1000}
                      style={{
                        background: '#3ADFA3',
                        color: 'white',
                        fontWeight: 600,
                        marginRight:
                          passedResourcesCount > 99
                            ? '-7px'
                            : passedResourcesCount > 9
                            ? '-4px'
                            : '-1px',
                      }}
                    />
                  </div>
                }
                key="2"
              >
                <SingleSignatureResourcesTable {...signaturePassedResourcesTableProps} />
              </TabPane>
            )}

            {riskType !== 'malware' && riskType !== 'osVulnerability' && remediationSteps && (
              <TabPane tab="Remediation" key="3">
                <Playbooks
                  signature={signatureName}
                  cloudAccounts={cloudAccounts}
                  service={service}
                />
                <SingleSignatureRemediationSteps remediationSteps={remediationSteps} />
              </TabPane>
            )}
          </Tabs>
        </Card>
      </div>
    );
  }
}

export default SingleSignatureTabs;

function getFailedResources(data, description) {
  let resourcesWithRisks =
    data &&
    data.reduce((acc, eachRisk) => {
      let riskWithFailedRes = eachRisk.risks.filter(
        val => val.signatureName === description && val.status.toLowerCase() === 'fail'
      );
      // for cloud xray risks
      if (eachRisk.hasOwnProperty('cloudXRayRisks')) {
        let failedCloudXrayResources = [];
        if (description && description.toLowerCase().includes('cve')) {
          failedCloudXrayResources = Object.values(eachRisk.cloudXRayRisks.CVEs).filter(
            val => val.cveID === description && val.status.toLowerCase() === 'fail'
          );
        } else {
          // this case is for malwares but since there's not identifier for malware name, the code comes in this block even if it is a signature
          // so failedCloudXrayResources will be empty and drawer will only the correct resources
          failedCloudXrayResources = Object.values(eachRisk.cloudXRayRisks.malwares).filter(
            val => val.malwareId === description && val.status.toLowerCase() === 'fail'
          );
        }
        riskWithFailedRes = [...riskWithFailedRes, ...failedCloudXrayResources];
      }
      if (riskWithFailedRes.length === 0) return acc;
      eachRisk.resourceStatus = 'fail';

      return [...acc, eachRisk];
    }, []);

  return resourcesWithRisks;
}

function getPassedResources(data, description) {
  let resourcesWithRisks =
    data &&
    data.reduce((acc, eachRisk) => {
      // loop risks
      const riskWithFailedRes = eachRisk.risks.filter(
        val => val.signatureName === description && val.status.toLowerCase() === 'pass'
      );

      if (riskWithFailedRes.length === 0) return acc;
      eachRisk.resourceStatus = 'pass';

      return [...acc, eachRisk];
    }, []);

  return resourcesWithRisks;
}
